import { render } from "./NostoProductRecommendations.vue?vue&type=template&id=4b5d766a&scoped=true"
import script from "./NostoProductRecommendations.vue?vue&type=script&lang=js"
export * from "./NostoProductRecommendations.vue?vue&type=script&lang=js"

import "./NostoProductRecommendations.vue?vue&type=style&index=0&id=4b5d766a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5d766a"]])

export default __exports__